import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from '@react-hook/debounce';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';

import { Button } from '../../../../components';

const PatientNameFilter = ({ onDataChange }) => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [dbFirstName, setDBFirstName, setImmediateFirstName] = useDebounce('', 500);
	const [dbLastName, setDBLastName, setImmediateLastName] = useDebounce('', 500);

	useEffect(() => {
		setDBFirstName(firstName);
	}, [firstName]);
	useEffect(() => {
		setDBLastName(lastName);
	}, [lastName]);

	useEffect(() => {
		const data = {};
		if (!isEmpty(dbFirstName)) {
			data.patient_first_name = dbFirstName;
		}
		if (!isEmpty(dbLastName)) {
			data.patient_last_name = dbLastName;
		}
		onDataChange(data);
	}, [dbFirstName, dbLastName]);

	const handleClearFirstName = () => {
		setFirstName('');
		setImmediateFirstName('');
	};

	const handleClearLastName = () => {
		setLastName('');
		setImmediateLastName('');
	};

	return (
		<div className="panel panel-primary patient-filter">
			<div className="panel-heading">Patient Name Filter</div>
			<div className="panel-body">
				<div className="form-group">
					<input
						type="text"
						autoComplete="off"
						className="form-control"
						placeholder="First Name"
						onChange={({ target }) => setFirstName(target.value)}
						value={firstName}
					/>
					<Button
						icon="close"
						className={cn({ 'hidden': firstName === '' })}
						onClick={handleClearFirstName}
					/>
				</div>
				<div className="form-group">
					<input
						type="text"
						autoComplete="off"
						className="form-control"
						placeholder="Last Name"
						onChange={({ target }) => setLastName(target.value)}
						value={lastName}
					/>
					<Button
						icon="close"
						className={cn({ 'hidden': lastName === '' })}
						onClick={handleClearLastName}
					/>
				</div>
			</div>
		</div>
	);
};

PatientNameFilter.propTypes = {
	onDataChange: PropTypes.func
};

export default PatientNameFilter;
